export const TIMEZONES = [
  ["America/New_York", "US Eastern"], ["America/Chicago", "US Central"], ["America/Denver", "US Mountain"], ["America/Phoenix", "Arizona"],
  ["America/Los_Angeles", "US Pacific"], ["America/Anchorage", "Alaska"], ["Pacific/Honolulu", "Hawaii"], ["America/Toronto", "Toronto"],
  ["America/Mexico_City", "Mexico City"], ["America/Sao_Paulo", "São Paulo"], ["UTC", "UTC"], ["Europe/London", "London"], ["Europe/Paris", "Paris"],
  ["Europe/Berlin", "Berlin"], ["Europe/Madrid", "Madrid"], ["Asia/Dubai", "Dubai"], ["Asia/Kolkata", "India"], ["Asia/Singapore", "Singapore"],
  ["Asia/Tokyo", "Tokyo"], ["Australia/Sydney", "Sydney"],
];

export const LOCAL_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export function tzOptions(current) {
  const list = [...TIMEZONES];
  [LOCAL_TZ, current].forEach((z) => { if (z && !list.some(([id]) => id === z)) list.unshift([z, z.replace(/_/g, " ")]); });
  return list;
}

export const tzLabel = (id, label) => `${label}${label !== id ? ` · ${id}` : ""}${id === LOCAL_TZ ? " (your time)" : ""}`;
